// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3tHji","header":"PatientBlock_header__3M3sU","label":"PatientBlock_label__evdBl","option":"PatientBlock_option__16wg7"};